export enum BroadcastPacketType {
    mouseMove = 'MOUSE_MOVE',
    hardReload = 'HARD_RELOAD',
    reaction = 'REACTION',
    syncedElementUpdate = 'SYNCED_ELEMENT_UPDATE',
    endCall = 'END_CALL',
}
